import { ReactComponent as ArrowUpIcon } from '../../../../assets/images/iconsv2/arrow-up.svg';

import MultiSelectBox from 'Components/Elements/Buttons/MultiSelectBox';
import { useTrans } from 'core/hooks';
import actions from 'core/redux/features/filters/actions';
import { selectAreaFilterOptions } from 'core/redux/features/filters/reducers';
import { ActiveFiltersType, IArea } from 'core/redux/features/filters/types';
import {
  selectActiveParentCity,
  selectActiveProductType,
} from 'core/redux/features/products/reducers/productTypes';
import { AppState, selectDeviceType } from 'core/redux/reducers';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { activeFilterToggled, useFilterState } from '../store';
import FilterItem from './FilterItem';

export const AreaFilter = (props: {
  parentRef: React.RefObject<HTMLElement>;
}) => {
  const { parentRef } = props;
  const trans = useTrans();
  const {
    filterDispatch,
    filterState: { activeFilter },
  } = useFilterState();
  const dispatch = useDispatch();

  // state selectors
  const activeFilters = useSelector(
    (state: AppState) => state.filters.activeFilters,
  );

  const options = useSelector(selectAreaFilterOptions);
  const deviceType = useSelector(selectDeviceType);
  //   const activeProductType = useSelector(selectActiveProductType);
  const parentAreas = useSelector((state: AppState) => state.parentAreas);
  const parentActiveArea = useSelector(selectActiveParentCity);
  /////

  // set in active city
  const [_inActiveParentCity, setInActiveParentCity] = useState<IArea>();
  useEffect(() => {
    setInActiveParentCity(
      parentAreas.find(item => parentActiveArea.id !== item.id),
    );
  }, [parentActiveArea, parentAreas]);
  /////

  // set name prefix counter
  const [namePrefix, setNamePrefix] = useState('');
  const totalFilter = activeFilters.areas.length;
  useEffect(() => {
    if (totalFilter > 0) {
      setNamePrefix(` (${totalFilter} ${trans('selected')})`);
    } else {
      setNamePrefix('');
    }
  }, [totalFilter, trans]);
  /////

  // temporary save state then later when user click save we will push the state in redux
  const [selected, setSelected] = useState<number[]>(activeFilters.areas);
  useEffect(() => {
    setSelected(activeFilters.areas);
  }, [activeFilters.areas]);

  return (
    <FilterItem
      onClick={() => {
        filterDispatch(activeFilterToggled('areas'));
      }}
      name="filter-areas"
      className="filter-checkbox-column"
      // hideArrowIcon={deviceType === 'mobile'}
      isOpen={activeFilter === 'areas'}
    >
      <MultiSelectBox
        controlMobile={deviceType === 'mobile'}
        onClose={() => {
          filterDispatch(activeFilterToggled('areas'));
        }}
        onSave={areas => {
          dispatch(actions.selectAreas(areas as number[]));
        }}
        parentRef={parentRef}
        name={trans('filter_area') + namePrefix}
        id="areas"
        options={options}
        selectedOptions={selected}
        isActiveDropdown={activeFilter === 'areas'}
        // extraButtons={[
        //   {
        //     hide:
        //       inActiveParentCity &&
        //       activeProductType.supported_city.indexOf(inActiveParentCity.id) <
        //         0,
        //     label: (
        //       <span
        //         style={{
        //           whiteSpace:
        //             deviceType === 'mobile' ? 'normal' : 'break-spaces',
        //           width: deviceType === 'mobile' ? '' : '100px',
        //         }}
        //       >
        //         {trans('change_parent_city', {
        //           city: inActiveParentCity?.label,
        //         })}
        //       </span>
        //     ),
        //     className: 'is-outlined is-plain is-change-parent',
        //     onClick: () => {
        //       window.location.href = trans(
        //         `routes.${activeProductType.id}_by_city`,
        //         { city: inActiveParentCity?.slug },
        //       );
        //     },
        //   },
        // ]}
      />
      {deviceType === 'mobile' ? null : (
        <ArrowUpIcon className="dropdown-content-arrow" />
      )}
    </FilterItem>
  );
};

interface IOwnProps {
  parentRef: React.RefObject<HTMLElement>;
  activeFilters: ActiveFiltersType;
  name: string;
  onSave?: (areas: number[]) => void;
  onClose?: () => void;
  isActiveDropdown: boolean;
  onClickField: () => void;
}

type TProps = IOwnProps;

function FilterAreasComponent({
  name,
  parentRef,
  isActiveDropdown,
  activeFilters,
  onClickField,
  onClose,
  onSave,
}: TProps) {
  const dispatch = useDispatch();
  const trans = useTrans();
  const {
    deviceType,
    areas,
    parentAreas,
    parentActiveArea,
    activeProductType,
    // local,
  } = useSelector((state: AppState) => ({
    areas: selectAreaFilterOptions(state),
    parentActiveArea: selectActiveParentCity(state),
    activeProductType: selectActiveProductType(state),
    parentAreas: state.parentAreas,
    deviceType: state.deviceType,
    // local: state.local,
  }));

  const onSaveAreas = (areas: number[] | string[]) => {
    dispatch(actions.selectAreas(areas as number[]));

    if (onSave) {
      onSave(areas as number[]);
    }

    // if (onClose) {
    //   onClose()
    // }
  };

  const [namePrefix, setNamePrefix] = useState('');
  const totalFilter = activeFilters.areas.length;
  useEffect(() => {
    if (totalFilter > 0) {
      setNamePrefix(` (${totalFilter} ${trans('selected')})`);
    } else {
      setNamePrefix('');
    }
  }, [totalFilter, trans]);

  const inActiveParentCity = parentAreas.find(
    item => parentActiveArea.id !== item.id,
  );

  return (
    <FilterItem
      onClick={() => {
        onClickField();
      }}
      name="filter-areas"
      // hideArrowIcon={deviceType === 'mobile'}
      isOpen={isActiveDropdown}
    >
      <MultiSelectBox
        controlMobile={false}
        onClose={() => onClose && onClose()}
        onSave={onSaveAreas}
        parentRef={parentRef}
        name={name + namePrefix}
        id="areas"
        options={areas}
        selectedOptions={activeFilters.areas}
        isActiveDropdown={isActiveDropdown}
        extraButtons={[
          {
            label: (
              <span
                style={{
                  whiteSpace:
                    deviceType === 'mobile' ? 'normal' : 'break-spaces',
                  width: deviceType === 'mobile' ? '' : '100px',
                }}
              >
                {trans('change_parent_city', {
                  city: inActiveParentCity.label,
                })}
              </span>
            ),
            className: 'is-outlined is-plain is-change-parent',
            onClick: () => {
              window.location.href = trans(
                `routes.${activeProductType.id}_by_city`,
                { city: inActiveParentCity.slug },
              );
            },
          },
        ]}
      />
      {deviceType === 'mobile' ? null : (
        <ArrowUpIcon className="dropdown-content-arrow" />
      )}
    </FilterItem>
  );
}

// const FilterAreas =
//   process.env.NODE_ENV !== 'production'
//     ? hot(FilterAreasComponent)
//     : FilterAreasComponent;

export default FilterAreasComponent;
